import Vue from 'vue'
import Router from 'vue-router'

import {auth} from './auth'

import simpleLayout from './layouts/simple'
import mainLayout from './layouts/main'
import statements from './views/statement/statements'
import uploadStatement from './views/statement/upload-statement'
import statement from './views/statement/statement'
import gateways from './views/gateway/gateways'
import row from './views/row/row'
import match from './views/match/match'
import matching from './views/match/matching'
import balance from './views/balance/balance'
import review from './views/review/review'
import autoFee from './views/fee/auto-fee'
import approveAdjustment from './views/adjustment/approve-adjustment'
import accountsReport from './views/accounts/accounts-report'
import login from './views/login'
import error from './views/error'
import oauth from './views/oauth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'login',
    },
    {
      path: '/login',
      name: 'login',
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: login,
      },
    },
    {
      path: '/oauth2/redirect',
      name: 'authentication',
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: oauth,
      },
    },
    {
      path: '/statements',
      name: 'statements',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: statements,
      },
    },
    {
      path: '/statement/upload',
      name: 'statement-upload',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: uploadStatement,
      },
    },
    {
      path: '/statement/:id(\\d+)',
      name: 'statement-view',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: statement,
      },
    },
    {
      path: '/row/:id(\\d+)',
      name: 'row-view',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: row,
      },
    },
    {
      path: '/match/:id(\\d+)',
      name: 'match-view',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: match,
      },
    },
    {
      path: '/matching/:gateway(\\S+)',
      name: 'matching',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: matching,
      },
    },
    {
      path: '/balance/:gateway(\\S+)/:source(\\S+)',
      name: 'balance',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: balance,
      },
    },
    {
      path: '/review/:gateway(\\S+)',
      name: 'review',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: review,
      },
    },
    {
      path: '/fee/auto/:gateway(\\S+)/:source(\\S+)/:currencyId(\\d+)',
      name: 'auto-fee',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: autoFee,
      },
    },
    {
      path: '/gateways',
      name: 'gateways',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: gateways,
      },
    },
    {
      path: '/adjustment/approve',
      name: 'approve-adjustment',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: approveAdjustment,
      },
    },
    {
      path: '/accounts-report/:gateway(\\S+)/:source(\\S+)',
      name: 'accounts-report',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: accountsReport,
      },
    },
    {
      path: '/error',
      name: 'error',
      meta: { requiresAuth: true },
      components: {
        layout: mainLayout,
        content: error,
      },
    },
    {
      path: '*',
      redirect: 'error',
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.name === 'login' && auth.authenticated()) {
    next({ name: 'gateways' })
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!auth.authenticated()) {
      next({
        name: 'login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
